import { Button, styled, ButtonProps } from '@mui/material';

interface CustomButtonProps extends ButtonProps {
  customcolor?: 'green' | 'blue';
}

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'customcolor',
})<CustomButtonProps>(({ theme, customcolor, variant }) => {
  const palette = customcolor === 'green' ? theme.palette.success : theme.palette.primary;
  const outlined = variant === 'outlined';
  return {
    backgroundColor: outlined ? 'transparent' : palette.main,
    color: outlined ? palette.main : palette.contrastText,
    border: '1px solid ' + (outlined ? theme.palette.divider : 'transparent'),
    '&:hover': {
      backgroundColor: outlined ? theme.palette.action.hover : palette.dark,
      borderColor: outlined ? palette.main : 'transparent',
    },
    '&.Mui-disabled': {
      backgroundColor: outlined ? 'transparent' : theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  };
});

export default StyledButton;
